import { Link, Typography } from "@material-ui/core";
import React from "react";

const NotFound = () => {
  return (
    <div className="error-page">
      <img src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`} alt="logo" />
      <div className="title">
        <Typography className="text" component="span">
          La página que estás buscando no existe.
        </Typography>
        <span className="emoji" role="img" aria-label="emoticon">
          🤔
        </span>
      </div>
      <Typography className="mail" align="center" gutterBottom>
        Consúltanos a <Link href="mailto:hola@carritofacil.cl">hola@carritofacil.cl</Link>
      </Typography>
    </div>
  );
};

export default NotFound;
